export const EXISTING_ROUTABLE_ACCOUNT_ERROR = 'It looks like you already have an account on Routable, with a different company.' +
    ' Please enter in your existing credentials.';
